import { Box, Skeleton } from '@chakra-ui/react';
import React from 'react';

interface MobileCartSkeletonProps {
  showMobileBackground: boolean;
}

export const MobileCartSkeleton: React.FC<MobileCartSkeletonProps> = ({ showMobileBackground }) => {
  return (
    <Box
      w="full"
      zIndex={5}
      position="relative"
      pointerEvents="auto"
      mb={showMobileBackground ? '0' : '8'}
      bgColor={showMobileBackground ? 'transparent' : 'var(--bg, #FFF)'}
    >
      <Skeleton
        p={4}
        bg="var(--card-bg, #FFF)"
        height="6.25rem"
        borderRadius="3xl"
        mx={showMobileBackground ? 0 : 2}
        boxShadow="2px 2px 10px 0px rgba(0, 0, 0, 0.05), -2px -2px 12px 0px rgba(0, 0, 0, 0.05)"
        sx={
          showMobileBackground
            ? {
                backdropFilter: 'blur(16px)',
                WebkitBackdropFilter: 'blur(16px)',
              }
            : {}
        }
      />
    </Box>
  );
};
